import React from 'react'
import Dialog from '@mui/material/Dialog'
import { FormProvider } from 'react-hook-form'
import { DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, TextField } from '@mui/material'
import SubmitButton from '../../commonUIComponents/SubmitButton'

const ResetPasswordModal = ({ methods, open, onClose, submitOnSuccess }) => {
  const { handleSubmit, register, formState: { errors } } = methods

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitOnSuccess)}>
          <DialogTitle>Reset your password</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Enter your email address or username and we’ll send you a link to reset your password
            </DialogContentText>
            <Grid container spacing={2} sx={{ marginTop: '0.5rem' }}>
              <Grid item xs={12}>
                <TextField
                  label="Username or Email address"
                  fullWidth
                  autoFocus
                  required
                  margin="dense"
                  variant="standard"
                  {...register('resetPasswordUsername', { required: { value: true, message: 'Invalid format', pattern: /^[A-Za-z0-9]+$/ } })}
                  error={errors.resetPasswordUsername}
                  helperText={errors.resetPasswordUsername?.message}
                />
              </Grid>
            </Grid>
            <DialogActions>
              <SubmitButton buttonLabel="Reset Password" textAlign="right"/>
            </DialogActions>
          </DialogContent>
        </form>
      </FormProvider>
    </Dialog>
  )
}

export default ResetPasswordModal
